import { render, staticRenderFns } from "./Ordinance.vue?vue&type=template&id=3b862ff2&scoped=true&"
import script from "./Ordinance.vue?vue&type=script&lang=ts&"
export * from "./Ordinance.vue?vue&type=script&lang=ts&"
import style0 from "./Ordinance.vue?vue&type=style&index=0&id=3b862ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b862ff2",
  null
  
)

export default component.exports